<div style="margin-top: 10px">
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <div class="input-header-group">
                    <span class="input-header">Jobs Filter</span>
                    <wj-multi-select
                        style="width: 300px"
                        [itemsSource]="activeJobsList()"
                        [placeholder]="'Choose Jobs'"
                        [selectedValuePath]="'value'"
                        [displayMemberPath]="'display'"
                        [checkedMemberPath]="'selected'"
                        [showSelectAllCheckbox]="true"
                        [showFilterInput]="true"
                        [maxHeaderItems]="1"
                        (checkedItemsChanged)="refresh()"
                    ></wj-multi-select>
                </div>

                <div class="input-header-group">
                    <span class="input-header">Show Series By</span>
                    <wj-combo-box
                        id="isActive"
                        style="width: 125px"
                        [(ngModel)]="selectedSeriesType"
                        name="isActive"
                        [itemsSource]="seriesTypes"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        (ngModelChange)="refresh()"
                    ></wj-combo-box>
                </div>
            </form>
        </div>
    </div>
    <div class="row">
        @if (chartData) {
            <div class="col-12">
                <wj-flex-chart
                    appAutoSize
                    [itemsSource]="chartData.points"
                    [bindingX]="'label'"
                    [chartType]="chartData.chartType"
                    [header]="chartData.title"
                    [stacking]="chartData.stacking"
                    [legendToggle]="true"
                >
                    <wj-flex-chart-legend [position]="'Right'"></wj-flex-chart-legend>
                    <wj-flex-chart-axis [wjProperty]="'axisY'" [title]="'Hours'" [format]="'N0'" [min]="0"></wj-flex-chart-axis>
                    @for (serie of chartData.series; track serie.binding) {
                        <wj-flex-chart-series [binding]="serie.binding" [name]="serie.name"> </wj-flex-chart-series>
                    }
                </wj-flex-chart>
            </div>
        }
    </div>
</div>
